import { getArrayApiClient } from 'adapter/out/client/apiClient';
import User from 'domain/entity/user';

const readUsersApiClient = getArrayApiClient(() => `users?start=0&limit=5000`, User);

export default readUsersApiClient;
